import { Icon, IconButton, Menu } from '@zillow/constellation-10';
import { IconMoreVerticalFilled } from '@zillow/constellation-icons';

export type OverflowMenuItem = {
  label: string;
  onSelect?: () => void;
};

type Props = {
  items: Array<OverflowMenuItem>;
  triggerLabel: string;
  disabled?: boolean;
};

const FlexiblePropertyCardOverflowMenu = ({ items, triggerLabel, disabled = false }: Props) => {
  // The menu can live inside a row-wrapping anchor and/or a clickable card, so clicks here must not
  // follow the row's link (preventDefault) or bubble up to those handlers (stopPropagation).
  const stopRowNavigation = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Menu.Root>
      <Menu.Trigger>
        <IconButton
          aria-label={triggerLabel}
          tone="brand"
          emphasis="bare"
          title={triggerLabel}
          size="md"
          disabled={disabled}
          onClick={stopRowNavigation}
          data-testid="FlexiblePropertyCard-OverflowMenuTrigger"
        >
          <Icon render={<IconMoreVerticalFilled />} />
        </IconButton>
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Content>
          {items.map((item) => (
            <Menu.Item
              key={item.label}
              onClick={(event) => {
                stopRowNavigation(event);
                item.onSelect?.();
              }}
            >
              <Menu.ItemLabel>{item.label}</Menu.ItemLabel>
            </Menu.Item>
          ))}
        </Menu.Content>
      </Menu.Portal>
    </Menu.Root>
  );
};

export { FlexiblePropertyCardOverflowMenu };
